import { TCloseAuthorizationTrap } from '../../actions/authorization_trap';

export const AUTHORIZATION_TRAP_CLOSE: TCloseAuthorizationTrap = 'authorizationTrap/close';
